/**
 * Feature flag constants organized by targeting type.
 * Each flag key must match the key defined in the AppConfig feature-flags JSON.
 *
 * ALLOWLIST_FLAGS: Enabled for specific aliases listed in the flag config.
 * PERCENTAGE_FLAGS: Enabled for a percentage of users via consistent hashing.
 * ORG_FLAGS: Enabled for users under a specific supervisor (requires supervisorChain context).
 * BRAVEHEARTS_FLAGS: Enabled for users in the Bravehearts program (checks DDB membership).
 */

export const ALLOWLIST_FLAGS = {
  VERBOSE_SUMMARIES: "verbose_summaries_allowlist",
  BRAVEHEART_UI: "braveheart_ui_allowlist",
};

export const PERCENTAGE_FLAGS = {
  VERBOSE_SUMMARIES: "verbose_summaries_percentage",
};

export const ORG_FLAGS = {
  VERBOSE_SUMMARIES: "verbose_summaries_org",
};

export const BRAVEHEARTS_FLAGS = {
  IS_ELIGIBLE: "bravehearts_eligible",
};
